"use client";
import PlayButton from "./PlayButton";
import { cn } from "@/lib/utils";

export default function VideoCard({ imageUrl, className }) {
  return (
    <div className={cn("relative w-full rounded-2xl overflow-hidden", className)}>
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.47), rgba(0, 0, 0, 0.47)), url('${imageUrl}')`,
        }}
      />
      <div className="relative w-full h-full flex items-center justify-center">
        <PlayButton />
      </div>
    </div>
  );
}

